import { Directive, HostBinding } from '@angular/core';

/** Replaces the send button for as long as it is projected. */
@Directive({
  selector: 'glxy-composer-send-override, [glxyComposerSendOverride]',
  standalone: false,
})
export class ChatComposerSendOverrideDirective {
  @HostBinding('class') class = 'glxy-composer-send-override glxy-composer-send-enter';
}
